const isDevOrLive =
  process.env.NODE_ENV === 'development' || process.env.GATSBY_LIVE == 'true'

export default isDevOrLive
